import { useApiRead } from "source/shared/SessionApiResource"

export function useCurrentPersonLinkedAccounts() {
  return useApiRead(`/people/v2/me/connected_people`).data
}
